import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  APIConfigurationIcon,
  BackArrowIcon,
  BillingOperationsIcon,
  CancellationRulesIcon,
  DunningManagementIcon,
  EmailConfigurationIcon,
  GeneralIcon,
  PlatformBrandingIcon,
  QuotePoliciesIcon,
  SandboxModeIcon,
  SecurityIcon,
  StaffManagementIcon,
} from "../../assets/icons";
import General from "./General";
import Security from "./Security";
import APIConfiguration from "./APIConfiguration";
import EmailConfiguration from "./EmailConfiguration";
import BillingOperations from "./BillingOperations";
import DunningManagement from "./DunningManagement";
import QuotePolicies from "./QuotePolicies";
import CancellationRules from "./CancellationRules";
import PlatformBranding from "./PlatformBranding";
import SandboxMode from "./SandboxMode";
import StaffManagement from "./StaffManagement";
import { reqToGetSettings } from "../../redux/slices.js/settings/settingsSlice";

const tabs = [
  { name: "General", icon: GeneralIcon, category: "general" },
  { name: "Security", icon: SecurityIcon, category: "security" },
  { name: "API Configuration", icon: APIConfigurationIcon, category: "api" },
  {
    name: "Email Configuration",
    icon: EmailConfigurationIcon,
    category: "smpt",
  },
  {
    name: "Billing Operations",
    icon: BillingOperationsIcon,
    category: "billing",
  },
  {
    name: "Dunning Management",
    icon: DunningManagementIcon,
    category: "dunning",
  },
  { name: "Quote Policies", icon: QuotePoliciesIcon, category: "quote" },
  {
    name: "Cancellation Rules",
    icon: CancellationRulesIcon,
    category: "cancellation",
  },
  {
    name: "Platform Branding",
    icon: PlatformBrandingIcon,
    category: "branding",
  },
  { name: "Sandbox Mode", icon: SandboxModeIcon, category: "sandbox" },
  { name: "Staff Management", icon: StaffManagementIcon, category: "staff" },
];

const Setting = () => {
  const [activeTab, setActiveTab] = useState("General");
  const dispatch = useDispatch();
  const settingsState = useSelector((state) => state.settings || {});
  const { settingDetails = [], loader } = settingsState;

  useEffect(() => {
    const selectedTab = tabs.find((tab) => tab.name === activeTab);
    if (selectedTab) {
      dispatch(
        reqToGetSettings({
          category: selectedTab.category,
          onSuccess: (data) => console.log("Settings loaded", data),
          onFailure: (err) => console.error(err),
        })
      );
    }
  }, [activeTab, dispatch]);

  const renderTabContent = () => {
    switch (activeTab) {
      case "General":
        return <General settings={settingDetails} />;
      case "Security":
        return <Security settings={settingDetails} />;
      case "API Configuration":
        return <APIConfiguration settings={settingDetails} />;
      case "Email Configuration":
        return <EmailConfiguration settings={settingDetails} />;
      case "Billing Operations":
        return <BillingOperations settings={settingDetails} />;
      case "Dunning Management":
        return <DunningManagement settings={settingDetails} />;
      case "Quote Policies":
        return <QuotePolicies settings={settingDetails} />;
      case "Cancellation Rules":
        return <CancellationRules settings={settingDetails} />;
      case "Platform Branding":
        return <PlatformBranding settings={settingDetails} />;
      case "Sandbox Mode":
        return <SandboxMode settings={settingDetails} />;
      case "Staff Management":
        return <StaffManagement settings={settingDetails} />;
      default:
        return null;
    }
  };

  return (
    <div className="rounded-md border-[1px] border-solid border-[#F3EFEF] space-y-5 md:space-y-8 pb-6 h-full setting-page">
      {/* Header */}
      <div className="p-3 sm:p-6 bg-[#F5FFBD] space-y-6">
        <div className="mb-4">
          <button type="button" className="text-[16px] font-normal flex gap-1">
            {BackArrowIcon} Back
          </button>
        </div>
        <div className="heading flex gap-2 justify-between items-end">
          <div className="heading-title space-y-1">
            <h1 className="text-h2 !font-medium mb-0 text-[#4285F4]">
              Command Centre Settings
            </h1>
            <p className="text-span text-dark mb-0">
              Configure system-wide settings and preferences
            </p>
          </div>
        </div>
      </div>

      {/* Tabs & Content */}
      <div className="h-[calc(100%-180px)] flex setting-tabs">
        {/* Sidebar Tabs */}
        <div className="w-64 bg-white border-r setting-tab border-[#F0F0F0] border border-t border-b border-r rounded-tr-[10px] rounded-br-[10px] shadow-sm h-full overflow-y-auto scroll-none">
          <ul className="flex flex-col mb-0">
            {tabs.map((tab) => (
              <li key={tab.name}>
                <div
                  onClick={() => setActiveTab(tab.name)}
                  className={`w-full text-left px-4 py-2 text-span cursor-pointer flex items-center gap-2 ${
                    activeTab === tab.name
                      ? "bg-[#4285F4] text-[#F8FFCF] setting-active"
                      : "text-dark setting-nonactive"
                  }`}
                >
                  <span className="flex-none">{tab.icon}</span>
                  <span className="pb-0 text-span">{tab.name}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Content */}
        <div className="flex-1 px-3 h-full setting-tab-content">
          {loader ? (
            <div className="flex items-center justify-center h-full">
              Loading...
            </div>
          ) : (
            <form className="comman-form flex flex-col chart-card h-full !shadow-none !border-[#D3D6DA3B] overflow-y-auto scroll-none justify-between">
              {renderTabContent()}
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Setting;
